export default () => {
    return {
        status: false,
        message: 'Cargando..'
    }
}
